// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"bb0abf54","71":"1fc16f11","744":"b61fddde","788":"6e4c2a9b","824":"531cf419","962":"a65dd733"}[chunkId] + ".chunk.css";
};